import React, { useState } from "react";
import KaitouAndHensachi from './KaitouAndHensachi.jsx';
import MediaQuery from "react-responsive";

// 解答解説の公開期間もscheduleItemsと同じ時間で自動に切替るように設定する?
const scheduleItems = [
    { // #1
        name: "第1回",
        examDate: new Date('2025-09-23T09:00:00'),
        startTime: new Date('2025-08-24T12:00:00'), // Initial start
        endTime: new Date('2025-09-23T08:59:59'),   // Morning of exam
    },
    { // #2
        name: "第2回",
        examDate: new Date('2025-10-19T09:00:00'),
        startTime: new Date('2025-09-24T12:00:00'), // Day after #1 exam
        endTime: new Date('2025-10-19T08:59:59'),   // Morning of exam
    },
    { // #3
        name: "第3回",
        examDate: new Date('2025-11-24T09:00:00'),
        startTime: new Date('2025-10-20T12:00:00'), // Day after #2 exam
        endTime: new Date('2025-11-24T08:59:59'),   // Morning of exam
    },
    { // #4
        name: "第4回",
        examDate: new Date('2025-12-14T09:00:00'),
        startTime: new Date('2025-11-25T12:00:00'), // Day after #3 exam
        endTime: new Date('2025-12-14T08:59:59'),   // Morning of exam
    },
    { // #5
        name: "第5回",
        examDate: new Date('2026-01-18T09:00:00'),
        startTime: new Date('2025-12-15T12:00:00'), // Day after #4 exam
        endTime: new Date('2026-03-31T23:59:59'),   // End of fiscal year
    },
    {
        name: "第6回",
        examDate: new Date('2026-01-25T09:00:00'), // 例
        startTime: new Date('2026-01-19T12:00:00'),
        endTime: new Date('2026-01-28T08:59:59'),
    }
];

const getCurrentSchedule = () => {
    const now = new Date();
    return scheduleItems.find(item => now >= item.startTime && now <= item.endTime);
};

const formatMonthDay = (date) => {
    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    const weekday = date.toLocaleString("default", { weekday: "short" });
    return `${month}${day}日(${weekday})`;
};

// 共通化したPDFリンクボタン（社会の右に偏差値判定基準ボタン追加）
// 共通化したPDFリンクボタン（社会の右に偏差値判定基準ボタン追加）
const PdfLinks = ({ links, pdfButtonStyle }) => {
    const [showButton, setShowButton] = React.useState(false);

    React.useEffect(() => {
        // 現在の回を取得
        const currentSchedule = getCurrentSchedule();
        const now = new Date();

        if (currentSchedule) {
            // startTimeから4日後の16:00を計算
            const targetDate = new Date(currentSchedule.startTime);
            targetDate.setDate(targetDate.getDate() + 3);
            targetDate.setHours(16, 0, 0, 0);

            if (now >= targetDate) {
                setShowButton(true);
            }
        }
    }, []); // コンポーネントのマウント時にのみ実行


    return (
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
            {links.map(subject => (
                <React.Fragment key={subject.label}>
                    <a
                        href={subject.url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button style={pdfButtonStyle}>{subject.label}</button>
                    </a>
                    {/* 社会の右に偏差値判定基準ボタンを追加 */}
                    {/* 後で第何回が自動で取得できるように配列とファイル名を変更する必要性がある */}
                    {/* {subject.label === "社会" && showButton && (
                        <a
                            href="https://toitumosi.jp/img/kai4.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button style={{
                                ...pdfButtonStyle,
                                backgroundColor: "#009d80",
                                marginLeft: "10px"
                            }}>
                                偏差値判定基準
                            </button>
                        </a>
                    )} */}
                </React.Fragment>
            ))}
        </div>
    );
};

const subjectPdfLinks = [
    { label: "英語", url: "https://toitumosi.jp/pdf/ecH8CdL5e.pdf" },
    { label: "数学", url: "https://toitumosi.jp/pdf/suN2sA9mTY.pdf" },
    { label: "国語", url: "https://toitumosi.jp/pdf/kVi5Z7XEj.pdf" },
    { label: "理科", url: "https://toitumosi.jp/pdf/rGu9hQebX.pdf" },
    { label: "社会", url: "https://toitumosi.jp/pdf/sT3q8cCEr.pdf" },
];

const Public = () => {
    const currentSchedule = getCurrentSchedule();
    const [isDetailsVisible, setIsDetailsVisible] = useState(false);

    const toggleDetails = () => {
        setIsDetailsVisible(!isDetailsVisible);
    };

    const pdfButtonStyle = {
        backgroundColor: "#009d80", color: "white", padding: "8px 16px", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "1em", margin: "5px"
    };

    if (currentSchedule) {
        const { name, startTime, examDate } = currentSchedule;
        const now = new Date();
        if (now < startTime) {
            return <h1 className="font-weight-bold">現在、準備中です。</h1>;
        }

        // 解答解説ボタンの公開はstartTimeの4時間後
        const answerOpenTime = new Date(startTime.getTime() + 4 * 60 * 60 * 1000);
        const isAnswerOpen = now >= answerOpenTime;

        return (
            <div>
                <a href="#process" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <h1 className="font-weight-bold">
                        
                        {/* {name} {formatMonthDay(examDate)} {now < examDate ? <h4 className="mt-1">予約受付中 ▶</h4> : <h4 className="mt-1">今年度の試験は終了しました</h4>} */}
                    </h1>
                </a>
                {/* <KaitouAndHensachi /> */}
    

                {/* {isDetailsVisible && (
                    <div style={{ marginTop: "20px", padding: "20px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#f9f9f9", textAlign: 'left', width: '80%', margin: '20px auto' }}>
                        <h5>＜志望校別偏差値による判定基準・階層分布表について＞</h5>
                        <p style={{ paddingLeft: '1em' }}>HPトップ　→　個人成績表の見方　→　WEB判定登録をしていただけますと閲覧することができます。</p>

                        <h5 style={{ marginTop: '20px' }}>＜WEB判定登録について＞</h5>
                        <p style={{ paddingLeft: '1em' }}>初めて受験した答案用紙が郵送された後に整理番号・受験番号から登録できます。</p>
                        <p style={{ paddingLeft: '1em' }}>※統一模試を受験された方のみWEB判定をご利用できます。</p>
                        <p style={{ paddingLeft: '1em' }}>※統一模試を受験された回のみWEB判定をご利用できます。</p>
                        <p style={{ paddingLeft: '1em' }}>（例：第1回・第4回・第5回を受験するとその受験した回の成績を見る事が出来ます）</p>

                        <p style={{ paddingLeft: '1em', marginTop: '20px', fontWeight: 'bold', color: '#d9534f' }}>
                            ※統一模試の解答解説は、受験回の予約受付期間までの期間限定公開となります。保存したい方は、ダウンロードまたはスクリーンショット等で保存してください。
                        </p>

                        <PdfLinks links={subjectPdfLinks} pdfButtonStyle={pdfButtonStyle} />
                    </div>
                )} */}
                {/* <div style={{ marginTop: "30px" }}>
                    <p style={{ color: "red", fontSize: "1.5em", fontWeight: "bold" }}>注意事項</p>
                    <p style={{ fontSize: "1.5em", fontWeight: "bold" }}>各回、公開会場案内に載っている会場は</p>
                    <p style={{ fontSize: "1.5em", fontWeight: "bold" }}>受付開始　8：30　模試開始　9：00　になります</p>
                    <p style={{ color: "red", fontSize: "1.5em", fontWeight: "bold" }}>但し、土佐塾イオンモール高知教室のみ、各回</p>
                    <p style={{ color: "red", fontSize: "1.5em", fontWeight: "bold" }}>受付開始　12：30　模試開始　13：00になります</p>
                    <p style={{ fontSize: "1.5em", fontWeight: "bold" }}>お間違えの無いようにお越しください</p>
                </div> */}
            </div>
        );
    }

    // currentSchedule が undefined の場合に返す内容を追加
    return <h1 className="font-weight-bold">第1回の予約開始は8月下旬辺りを予定しています。</h1>;
    // return <h1 className="font-weight-bold">現在、準備中です。</h1>;
};

const PublicSp = () => {
    const currentSchedule = getCurrentSchedule();
    const [isDetailsVisible, setIsDetailsVisible] = useState(false);

    const toggleDetails = () => {
        setIsDetailsVisible(!isDetailsVisible);
    };

    const pdfButtonStyle = {
        backgroundColor: "#009d80", color: "white", padding: "8px 16px", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "0.9em", margin: "5px"
    };

    if (currentSchedule) {
        const { name, startTime, examDate } = currentSchedule;
        const now = new Date();
        if (now < startTime) {
            return <h4 className="font-weight-bold">現在、準備中です</h4>;
        }

        // 解答解説ボタンの公開はstartTimeの4時間後
        const answerOpenTime = new Date(startTime.getTime() + 4 * 60 * 60 * 1000);
        const isAnswerOpen = now >= answerOpenTime;

        return (
            <div>
                <a href="#process" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <h4 className="font-weight-bold">
                        {/* {name} {formatMonthDay(examDate)} {now < examDate ? <h6 className="mt-1">予約受付中 ▶</h6> : <h6 className="mt-1">今年度の試験は終了しました</h6>} */}
                    </h4>
                </a>
                <KaitouAndHensachi />
{/*      

                {isDetailsVisible && (
                    <div style={{ marginTop: "20px", padding: "15px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#f9f9f9", textAlign: 'left' }}>
                        <h5 style={{ fontSize: '1.1em' }}>＜志望校別偏差値による判定基準・階層分布表について＞</h5>
                        <p style={{ paddingLeft: '1em', fontSize: '0.9em' }}>HPトップ　→　個人成績表の見方　→　WEB判定登録をしていただけますと閲覧することができます。</p>

                        <h5 style={{ marginTop: '20px', fontSize: '1.1em' }}>＜WEB判定登録について＞</h5>
                        <p style={{ paddingLeft: '1em', fontSize: '0.9em' }}>初めて受験した答案用紙が郵送された後に整理番号・受験番号から登録できます。</p>
                        <p style={{ paddingLeft: '1em', fontSize: '0.9em' }}>※統一模試を受験された方のみWEB判定をご利用できます。</p>
                        <p style={{ paddingLeft: '1em', fontSize: '0.9em' }}>※統一模試を受験された回のみWEB判定をご利用できます。</p>
                        <p style={{ paddingLeft: '1em', fontSize: '0.9em' }}>（例：第1回・第4回・第5回を受験するとその受験した回の成績を見る事が出来ます）</p>

                        <p style={{ paddingLeft: '1em', marginTop: '20px', fontWeight: 'bold', color: '#d9534f' }}>
                            ※統一模試の解答解説は、受験回の予約受付期間までの期間限定公開となります。保存したい方は、ダウンロードまたはスクリーンショット等で保存してください。
                        </p>
                        <PdfLinks links={subjectPdfLinks} pdfButtonStyle={pdfButtonStyle} />
                    </div>
                )} */}
                {/* <div style={{ marginTop: "30px" }}>
                    <p style={{ color: "red", fontSize: "1.2em", fontWeight: "bold" }}>注意事項</p>
                    <p style={{ fontSize: "1.2em", fontWeight: "bold" }}>各回、公開会場案内に載っている会場は</p>
                    <p style={{ fontSize: "1.2em", fontWeight: "bold" }}>受付開始　8：30　模試開始　9：00　になります</p>
                    <p style={{ color: "red", fontSize: "1.2em", fontWeight: "bold" }}>但し、土佐塾イオンモール高知教室のみ、各回</p>
                    <p style={{ color: "red", fontSize: "1.2em", fontWeight: "bold" }}>受付開始　12：30　模試開始　13：00になります</p>
                    <p style={{ color: "red", fontSize: "1.2em", fontWeight: "bold" }}>お間違えの無いようにお越しください</p>
                </div> */}
            </div>
        );
    }

    // currentSchedule が undefined の場合に返す内容を追加
    return <h4 className="font-weight-bold">第1回の予約開始は8月下旬辺りを予定しています。</h4>;
    // return <h4 className="font-weight-bold">現在、準備中です。</h4>;
};

const PublicDeadline = () => {
    return (
        <>
            <MediaQuery query="(max-width: 768px)">
                <PublicSp />
            </MediaQuery>

            <MediaQuery query="(min-width: 769px)">
                <Public />
            </MediaQuery>
        </>
    );
};

export default PublicDeadline;